import React from "react";
import clsx from "clsx";
import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormCheckbox } from "components";

import styles from "../terminalSolution.module.scss";

type OptionsSectionProps = {
	sectionName: string;
	isLoading?: boolean;
	defaultValue: any;
};

const OptionsSection = ({
	sectionName,
	isLoading = false,
	defaultValue,
}: OptionsSectionProps) => {
	const { register } = useFormContext();
	return (
		<div data-autotest="optionsSection">
			<hr className={clsx(styles.divider, "mt-3 mb-4")} />
			<p className={styles.subHeader}>Options</p>
			<Row className="form-group">
				<Col md={2}>
					<HookFormCheckbox
						register={register}
						id={`${sectionName}.avsTerminalOption`}
						name={`${sectionName}.avs`}
						label="AVS"
						defaultCheckedByValue={defaultValue?.avs}
						className="mb-3"
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormCheckbox
						register={register}
						id={`${sectionName}.cvvTerminalOption`}
						name={`${sectionName}.cvv`}
						label="CVV"
						defaultCheckedByValue={defaultValue?.cvv}
						className="mb-3"
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormCheckbox
						register={register}
						id={`${sectionName}.multiMerchantTerminalOption`}
						name={`${sectionName}.multiMerchant`}
						label="MultiMerchant"
						defaultCheckedByValue={defaultValue?.multiMerchant}
						className="mb-3"
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormCheckbox
						register={register}
						id={`${sectionName}.tipAdjustTerminalOption`}
						name={`${sectionName}.tipAdjust`}
						label="Tip Adjust"
						defaultCheckedByValue={defaultValue?.tipAdjust}
						className="mb-3"
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormCheckbox
						register={register}
						id={`${sectionName}.serverNumberTerminalOption`}
						name={`${sectionName}.serverNumber`}
						label="Server #"
						defaultCheckedByValue={defaultValue?.serverNumber}
						className="mb-3"
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormCheckbox
						register={register}
						id={`${sectionName}.orderNumberTerminalOption`}
						name={`${sectionName}.orderNumber`}
						label="Order #"
						defaultCheckedByValue={defaultValue?.orderNumber}
						className="mb-3"
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormCheckbox
						register={register}
						id={`${sectionName}.amexTerminalOption`}
						name={`${sectionName}.amex`}
						label="AMEX"
						defaultCheckedByValue={defaultValue?.amex}
						className="mb-3"
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormCheckbox
						register={register}
						id={`${sectionName}.pinDebitTerminalOption`}
						name={`${sectionName}.pinDebit`}
						label="PIN Debit"
						defaultCheckedByValue={defaultValue?.pinDebit}
						className="mb-3"
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={3}>
					<HookFormCheckbox
						register={register}
						id={`${sectionName}.externalPinPadTerminalOption`}
						name={`${sectionName}.externalPinPad`}
						label="External PIN Pad"
						defaultCheckedByValue={defaultValue?.externalPinPad}
						className="mb-3"
						blurLoading={isLoading}
					/>
				</Col>
			</Row>
		</div>
	);
};

export default OptionsSection;
